/**
 * Mobile simulator - responsive testing tool
 *
 * Announces itself with a single boolean global whose name says exactly what it is.
 * Observed on version 4.19.3.
 */
import { probeGlobal } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ckejmhbmlajgoklhgbapkiccekfoccmk';
export const mobileSimulator: ExtensionDefinition = {
  id: ID,
  name: 'Mobile simulator - responsive testing tool',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  signals: [
    { id: 'global-has-mobilefirst', kind: 'global',
      description: 'Check for window.hasMobileFirstExtension — a main-world flag the extension sets on every page.',
      weight: 1, run: () => probeGlobal('hasMobileFirstExtension') },
  ],
};
